export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[800px] mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">联系我们</h2>
        <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
          欢迎漫画作者、汉化组和版权方与我们取得联系
        </p>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-6">
          <div className="bg-background-100 rounded-2xl p-6 md:p-8 border border-background-200/70 text-center">
            <div className="w-14 h-14 mx-auto rounded-2xl bg-accent-100 flex items-center justify-center">
              <i className="ri-mail-send-line text-2xl text-accent-600"></i>
            </div>
            <h3 className="font-heading text-base text-foreground-950 mt-4 mb-2">商务合作</h3>
            <p className="text-xs text-foreground-500">广告投放 · 品牌联名 · IP授权</p>
            <a href="#" className="inline-block mt-3 text-sm text-primary-500 font-medium whitespace-nowrap">business@pipicomic.com</a>
          </div>

          <div className="bg-background-100 rounded-2xl p-6 md:p-8 border border-background-200/70 text-center">
            <div className="w-14 h-14 mx-auto rounded-2xl bg-secondary-100 flex items-center justify-center">
              <i className="ri-user-heart-line text-2xl text-secondary-600"></i>
            </div>
            <h3 className="font-heading text-base text-foreground-950 mt-4 mb-2">作者投稿</h3>
            <p className="text-xs text-foreground-500">原创漫画 · 汉化投稿 · 平台入驻</p>
            <a href="#" className="inline-block mt-3 text-sm text-primary-500 font-medium whitespace-nowrap">author@pipicomic.com</a>
          </div>

          <div className="bg-background-100 rounded-2xl p-6 md:p-8 border border-background-200/70 text-center">
            <div className="w-14 h-14 mx-auto rounded-2xl bg-primary-100 flex items-center justify-center">
              <i className="ri-customer-service-2-line text-2xl text-primary-600"></i>
            </div>
            <h3 className="font-heading text-base text-foreground-950 mt-4 mb-2">用户反馈</h3>
            <p className="text-xs text-foreground-500">问题反馈 · 功能建议 · 举报投诉</p>
            <a href="#" className="inline-block mt-3 text-sm text-primary-500 font-medium whitespace-nowrap">support@pipicomic.com</a>
          </div>
        </div>
      </div>
    </section>
  );
}